import { render, staticRenderFns } from "./QuotationSelectedInsured.vue?vue&type=template&id=3e49e64e&scoped=true"
import script from "./QuotationSelectedInsured.vue?vue&type=script&lang=js"
export * from "./QuotationSelectedInsured.vue?vue&type=script&lang=js"
import style0 from "./QuotationSelectedInsured.vue?vue&type=style&index=0&id=3e49e64e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49e64e",
  null
  
)

export default component.exports